import React, { useMemo, useState } from "react";
import { useMediaQuery } from "react-responsive";
import LoadingSkeleton from "../../../loader/TableLoader";
import {
  NoItemsLeftInTable,
  capitalizeFirstLetter,
  formatFileSize,
  handleDateSetUp,
} from "../../../../helpers/helpers";
import { Modal } from "react-materialize";
import { useDispatch } from "react-redux";
import { downloadFile } from "../../../../redux/action/document";
import ViewDocument from "../component/ViewDocument";

function DocumentsTable({ documentValue, loadings }) {
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewDocument, setIsViewDocument] = useState(false);
  const [viewDocumentDetails, setViewDocumentDetails] = useState({});
  const dispatch = useDispatch();

  const memoizeddocumenttable = useMemo(
    () => documentValue?.files,
    [documentValue?.files]
  );

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className={`${!isTablet && "mt-1 table-container-style"} mt-2 mb-2`}>
      {loadings && memoizeddocumenttable !== 0 ? (
        <div className="valign-wrapper justify-center cover white">
          <LoadingSkeleton
            headerData={[
              "S.No",
              "Type of Document",
              "Uploaded document",
              "Status",
              "Action",
            ]}
            height={15}
          />
        </div>
      ) : (
        <>
          <table
            className={`responsive-table centered ${
              isTablet ? "auction_table table-style" : "custom-table-style"
            } `}
          >
            <thead className="grey lighten-4">
              <tr>
                <th>S.No</th>
                <th>Type of Document</th>
                <th>Uploaded document </th>
                <th>File Size</th>
                <th>Upload Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {memoizeddocumenttable?.map((items, index) => (
                <tr key={items.id}>
                  <td>{index + 1}</td>
                  <td style={{ width: !isTablet && "250px" }}>
                    {items?.fileType}
                  </td>
                  <td style={{ width: !isTablet && "350px" }}>
                    <span>{items?.fileName}</span>
                  </td>
                  <td>{formatFileSize(items?.fileSize)}</td>
                  <td>{handleDateSetUp(items?.uploadDate)}</td>

                  <td
                    className={`${
                      items?.status === "verified"
                        ? "green-text"
                        : items.status === "rejected"
                        ? "red-text text-accent-4"
                        : "amber-text"
                    }`}
                  >
                    {capitalizeFirstLetter(items?.status) || "..."}
                  </td>

                  <td>
                   <span className="valign-wrapper gap-2 justify-center">
                   <button
                      onClick={() => {
                        dispatch(downloadFile(items.fileId, items.fileName));
                      }}
                    >
                      <span className="material-symbols-outlined">download</span>
                    </button>
                    <span
                      className="material-symbols-outlined pointer"
                      onClick={() => {setIsViewDocument(true); setViewDocumentDetails(items)}}
                    >
                      visibility
                    </span>
                   </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {(memoizeddocumenttable?.length === 0 || !memoizeddocumenttable) && <NoItemsLeftInTable />}
        </>
      )}
      <Modal
        actions={[]}
        bottomSheet={false}
        fixedFooter={false}
        className="modelAccount"
        id="view-details"
        open={isModalOpen}
        options={{
          onCloseEnd: closeModal,
        }}
      >
        <img
          alt="img"
          style={{
            width: "150px",
            height: "150px",
          }}
        />
      </Modal>
      <Modal
        actions={[]}
        bottomSheet={false}
        fixedFooter={false}
        className="modelAccount"
        id="view-details"
        open={isViewDocument}
        options={{
          onCloseEnd: () => setIsViewDocument(false),
        }}
      >
        <ViewDocument
          setIsViewDocument={setIsViewDocument}
          fileId={viewDocumentDetails?.fileId}
        />
      </Modal>
    </div>
  );
}

export default DocumentsTable;
